import { render, staticRenderFns } from "./RightColumn.vue?vue&type=template&id=8a7ad90c&scoped=true&lang=pug"
import script from "./RightColumn.vue?vue&type=script&lang=js"
export * from "./RightColumn.vue?vue&type=script&lang=js"
import style0 from "./RightColumn.vue?vue&type=style&index=0&id=8a7ad90c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7ad90c",
  null
  
)

export default component.exports